<template>
  <div class="home">
    <MessageList  @clicked="onClickChild" @newMessage="onClickChildNew" @editMessage="onClickChild" v-show="listView" :scroll="corY" ref="refreshList" />
  </div>
</template>

<script>
// @ is an alias to /src
import MessageList from '@/components/message/MessageList.vue'

export default {
  name: 'MessageTemplate',
  components: {
    MessageList
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      message: {
        id: null,
        template_id: null,
        number: null,
        message: null,
        status: null,
        date: null,
        check: false,
        ref_no: null
      }
    }
  },
  methods: {
    onClickChild: function (value) {
      this.message = value
      this.listView = false
      this.formView = true
    },
    onClickChildNew: function () {
      this.message = {
        id: null,
        template_id: null,
        number: null,
        message: null,
        status: 'sent',
        date: null,
        check: false,
        ref_no: null
      }
      this.listView = false
      this.formView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  }
}
</script>
